import { formatar } from './v2/config';
import { iniciarMedicaoPagina } from './v2/medicao';
import { desempilhar, empilhar } from './v2/sobreposicao';
import { compartilharPagina, fecharCompartilhar, fecharSheet } from './v2/vaga';
import { fecharPop, iniciarVagasEmpresa } from './v2/vagasEmpresa';

// Página da empresa (renderEmpresa, empSpy e o visualizador da v30/v31). O servidor monta a página inteira; aqui
// ficam o atalho ativo, "Ler tudo", o vídeo no clique, as fotos e o compartilhar. A lista de vagas ("Ver mais vagas", os
// filtros e, no celular, a vaga no painel de baixo) é do js/v2/vagasEmpresa.js. A pílula da busca do celular é do topo
// (js/v2/topo.js), que baixa a busca em tela cheia no primeiro toque.
const $ = id => document.getElementById(id);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const cliqueComum = e => e.button === 0 && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey;
const lerJson = id => { try { return JSON.parse($(id)?.textContent || 'null'); } catch { return null; } };
const semAnimacao = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const E = lerJson('empresa-v2') || {};
const TE = E.textos || {};
const T = lerJson('busca-v2-textos') || {};
const logoInterno = E.logo ? `<img src="${esc(E.logo)}" alt="" width="44" height="44">` : esc(E.ini);

// ---------- atalho ativo: a seção que está logo abaixo da barra (o clique segura o destino até a rolagem terminar) ----------
let _segura = null;
let _quadro = 0;
const _alturaFixa = () => Math.max(0, document.querySelector('.site-h')?.getBoundingClientRect().bottom || 0) + (document.querySelector('.emp__nav')?.offsetHeight || 0);

function marcarAtalho() {
    const chips = $$('.emp__chips a').filter(a => a.offsetParent);
    if (!chips.length) {
        return;
    }
    const limite = _alturaFixa() + 24;
    let ativo = chips[0].dataset.empGo;
    if (_segura && Date.now() < _segura.ate) {
        ativo = _segura.id;
    } else {
        chips.forEach(c => {
            const sec = $(c.dataset.empGo);
            if (sec && sec.getBoundingClientRect().top <= limite) {
                ativo = c.dataset.empGo;
            }
        });
        // No fim da página fica marcada a última seção visível.
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
            const visiveis = chips.filter(c => {
                const r = $(c.dataset.empGo)?.getBoundingClientRect();
                return r && r.top < window.innerHeight && r.bottom > limite;
            });
            if (visiveis.length) {
                ativo = visiveis[visiveis.length - 1].dataset.empGo;
            }
        }
    }
    chips.forEach(c => {
        const on = c.dataset.empGo === ativo;
        c.classList.toggle('is-on', on);
        on ? c.setAttribute('aria-current', 'location') : c.removeAttribute('aria-current');
    });
    // No celular a barra rola de lado para o atalho ativo aparecer.
    const on = chips.find(c => c.dataset.empGo === ativo);
    const caixa = on?.parentElement;
    if (on && caixa) {
        const e = on.offsetLeft - caixa.offsetLeft;
        const d = e + on.offsetWidth;
        if (e < caixa.scrollLeft) {
            caixa.scrollLeft = e - 8;
        } else if (d > caixa.scrollLeft + caixa.clientWidth) {
            caixa.scrollLeft = d - caixa.clientWidth + 8;
        }
    }
}

function irParaSecao(id) {
    const sec = $(id);
    if (!sec) {
        return;
    }
    _segura = { id, ate: Date.now() + 700 };
    setTimeout(marcarAtalho, 720);
    marcarAtalho();
    const topo = sec.getBoundingClientRect().top - (_alturaFixa() + 12);
    window.scrollTo({ top: window.scrollY + topo, behavior: semAnimacao() ? 'auto' : 'smooth' });
    sec.setAttribute('tabindex', '-1');
    sec.focus({ preventScroll: true });
}

// ---------- fotos(visualizador em tela cheia: setas trocam, Esc fecha, o foco volta à foto) ----------
let _foto = 0;
let _fotoDe = null;
function abrirFoto(i, origem) {
    const fotos = E.fotos || [];
    const janela = $('lbx');
    if (!fotos.length || !janela) {
        return;
    }
    _foto = (i + fotos.length) % fotos.length;
    _fotoDe = origem || _fotoDe;
    $('lbxImg').src = fotos[_foto];
    $('lbxImg').alt = formatar(TE.fotoAlt, _foto + 1, fotos.length);
    $('lbxT').textContent = formatar(TE.fotoNDe, _foto + 1, fotos.length);
    if (!janela.open) {
        janela.showModal();
        // O Voltar do navegador ou do celular fecha as fotos (as setas não entram no histórico).
        empilhar('v2Lbx', () => janela.close());
        $('lbxClose').focus();
    }
}

// ---------- eventos ----------
function iniciarEventos() {
    document.addEventListener('click', e => {
        const t = e.target;

        const atalho = t.closest('[data-emp-go]');
        if (atalho && cliqueComum(e)) {
            e.preventDefault();
            irParaSecao(atalho.dataset.empGo);
            return;
        }

        // A lista de vagas (linha, "Ver mais" e os filtros) é do js/v2/vagasEmpresa.js.
        const lerTudo = t.closest('[data-emp-mais]');
        if (lerTudo) {
            const texto = $(lerTudo.getAttribute('aria-controls'));
            const abrir = lerTudo.getAttribute('aria-expanded') !== 'true';
            texto?.classList.toggle('is-clamp', !abrir);
            lerTudo.setAttribute('aria-expanded', String(abrir));
            lerTudo.textContent = abrir ? TE.mostrarMenos : TE.lerTudo;
            return;
        }

        // O player só entra depois do clique.
        const video = t.closest('[data-emp-video]');
        if (video) {
            const src = video.dataset.empVideo;
            const quadro = document.createElement('iframe');
            quadro.className = 'emp__video';
            quadro.src = `${src}${src.includes('?') ? '&' : '?'}autoplay=1`;
            quadro.title = TE.assistir || '';
            quadro.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            quadro.allowFullscreen = true;
            video.replaceWith(quadro);
            quadro.focus();
            return;
        }

        const foto = t.closest('[data-lbx]');
        if (foto) {
            abrirFoto(+foto.dataset.lbx, foto);
            return;
        }
        // O fundo azul (fora da foto e dos botões) também fecha o visualizador.
        if (t.closest('#lbxClose') || (t.closest('#lbx') && !t.closest('button, #lbxImg'))) {
            $('lbx').close();
            return;
        }
        if (t.closest('#lbxPrev')) {
            abrirFoto(_foto - 1);
            return;
        }
        if (t.closest('#lbxNext')) {
            abrirFoto(_foto + 1);
            return;
        }

        const compartilhar = t.closest('.js-emp-share');
        if (compartilhar) {
            compartilharPagina({
                link: E.url,
                titulo: E.nome,
                texto: E.compartilhar,
                linha: E.linha,
                logo: `<span class="card__logo" aria-hidden="true">${logoInterno}</span>`,
                rotuloLink: TE.linkPagina,
                cabecalho: TE.compartilharTitulo
            }, compartilhar);
        }
    });

    $('lbx')?.addEventListener('close', () => {
        desempilhar('v2Lbx');
        _fotoDe?.focus();
        _fotoDe = null;
    });

    document.addEventListener('keydown', e => {
        if ($('lbx')?.open) {
            if (e.key === 'ArrowLeft') {
                abrirFoto(_foto - 1);
            } else if (e.key === 'ArrowRight') {
                abrirFoto(_foto + 1);
            }
            return;
        }
        if (e.key === 'Escape' && !document.querySelector('dialog[open]')) {
            if (fecharCompartilhar() || fecharPop()) {
                return;
            }
            const aberto = $$('.sheet.is-open:not(#sheetMenu)').pop();
            if (aberto) {
                fecharSheet(aberto);
            }
        }
    });

    window.addEventListener('scroll', () => {
        if (_quadro) {
            return;
        }
        _quadro = requestAnimationFrame(() => {
            _quadro = 0;
            marcarAtalho();
        });
    }, { passive: true });
}

// ---------- início ----------
iniciarMedicaoPagina('empresa');
iniciarVagasEmpresa({
    caminho: E.caminho,
    anuncios: E.anuncios,
    textos: TE,
    textosBusca: T,
    alturaFixa: _alturaFixa,
    padrao: { empresa: E.nome, logo: logoInterno },
    vagaUrl: E.vagaUrl
});
iniciarEventos();
marcarAtalho();
